export type DeviceMode = 'mobile_responsive' | 'mobile_full' | 'tablet' | 'desktop' | 'custom';

export interface DeviceOption {
  key: DeviceMode;
  label: string;
  subtitle: string | null;
  width: number | null;
}

export const DEVICES: DeviceOption[] = [
  { key: 'mobile_responsive', label: 'MOBILE RESPONSIVE', subtitle: "Jusqu'à 320px de large", width: 320 },
  { key: 'mobile_full', label: 'MOBILE PLEINE LARGEUR', subtitle: "Jusqu'à 320px de large", width: 375 },
  { key: 'tablet', label: 'TABLETTE', subtitle: "Jusqu'à 768px de large", width: 768 },
  { key: 'desktop', label: 'ORDINATEUR', subtitle: 'Plus large que 800px', width: 900 },
  { key: 'custom', label: 'PERSONNALISÉ', subtitle: null, width: null },
];
